import IconHome from '../assets/images/navbar/home.svg';
import IconHomeActive from '../assets/images/navbar/home-active.svg';
import IconWeather from '../assets/images/navbar/weather.svg';
import IconDashboard from '../assets/images/navbar/dashboard.svg';
import IconEventLog from '../assets/images/navbar/event-log.svg';
import IconReport from '../assets/images/navbar/report.svg';
import IconCompany from '../assets/images/navbar/company.svg';
import IconSelection from '../assets/images/navbar/selection.svg';
import IconApp from '../assets/images/navbar/application.svg';
import IconBunkeringLog from '../assets/images/navbar/bunkering-log.svg';
import IconROB from '../assets/images/navbar/rob.svg';
import IconVoyage from '../assets/images/navbar/voyage.svg';

export default {
  IconHome,
  IconHomeActive,
  IconWeather,
  IconDashboard,
  IconEventLog,
  IconReport,
  IconCompany,
  IconSelection,
  IconApp,
  IconBunkeringLog,
  IconROB,
  IconVoyage,
};
